/* eslint-disable camelcase, no-var */
const PIXEL_ID = '7d0388ff-06ed-40b4-8d54-ebf47f6175f3'

function generatePixel() {
  /* prettier-ignore */
  ;(function(win, doc, sdk_url){ if(win.snaptr) return; var tr=win.snaptr=function(){ tr.handleRequest? tr.handleRequest.apply(tr, arguments):tr.queue.push(arguments); }; tr.queue = []; var s='script'; var new_script_section=doc.createElement(s); new_script_section.async=!0; new_script_section.src=sdk_url; var insert_pos=doc.getElementsByTagName(s)[0]; insert_pos.parentNode.insertBefore(new_script_section, insert_pos); })(window, document, 'https://sc-static.net/scevent.min.js');
}

export default function ({ app, store, isDev }) {
  generatePixel()
  init(store.state.user.details)

  /**
   * TODO: Add events
   * - Purchase
   */
  app.router.afterEach(() => setTimeout(() => track('PAGE_VIEW'), 0))
  app.$bus.$on('view-products', () => track('VIEW_CONTENT'))
  app.$bus.$on('view-product', () => track('VIEW_CONTENT'))
  app.$bus.$on('login', user => init(user))
  app.$bus.$on('register', user => {
    init(user)
    track('SIGN_UP')
  })
  app.$bus.$on('add-cart', () => track('ADD_CART'))

  function init(user) {
    const userOptions = user.id ? { user_email: user.email } : {}

    if (isDev) console.log('[snapchat] init', userOptions)
    window.snaptr('init', PIXEL_ID, userOptions)
  }

  function track(eventName, payload = {}) {
    if (isDev) console.log('[snapchat] track', eventName, payload)
    window.snaptr('track', eventName, payload)
  }
}
